/**
 * Numarul AWB-ului ca link spre urmarirea curierului (Madalin, 21.10.2026: „sa vezi exact ce s-a
 * intamplat cu el si cum arata acolo situatia").
 *
 * Adresele, verificate pe 21.10.2026:
 *   - FAN: `?tracking=` — pagina il pune singura in formular (`data-initial-tracking-number`);
 *   - Sameday: `#awb=` — forma din documentatia API-ului Sameday („URL tracking").
 * Curier necunoscut → doar numarul, fara link.
 */
import type { MouseEvent } from 'react'

export function linkUrmarire(curier: string, awb: string): string | null {
  const nr = encodeURIComponent(awb.trim())
  if (curier === 'FAN') return `https://www.fancourier.ro/awb-tracking/?tracking=${nr}`
  if (curier === 'SAMEDAY') return `https://sameday.ro/#awb=${nr}`
  return null
}

export function LinkAwb({
  curier,
  awb,
  className = 'font-mono',
}: {
  curier: string
  awb: string
  className?: string
}) {
  const href = linkUrmarire(curier, awb)
  if (!href) return <span className={className}>{awb}</span>
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      // Randul din lista e si el clicabil (deschide comanda); linkul nu trebuie sa-l declanseze.
      onClick={(e: MouseEvent) => e.stopPropagation()}
      title={`Deschide AWB-ul la ${curier === 'SAMEDAY' ? 'Sameday' : curier}`}
      className={`${className} text-b4l-blue underline decoration-dotted underline-offset-2 hover:decoration-solid`}
    >
      {awb}
    </a>
  )
}
